import { render } from "./NavElement.vue?vue&type=template&id=12c16dbd&scoped=true"
import script from "./NavElement.vue?vue&type=script&lang=js"
export * from "./NavElement.vue?vue&type=script&lang=js"

import "./NavElement.vue?vue&type=style&index=0&id=12c16dbd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c16dbd"]])

export default __exports__